// extracted by mini-css-extract-plugin
module.exports = {"title":"Intro_title__YF3MJ","inverted":"Intro_inverted__ljGcB","text":"Intro_text__PnK8L"};